import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

import bgImg from '@/assets/bg/settings-bg.png'
import { CounterWrapper } from '@/components/CountdownEvent/styles'
import { HeaderElem, HeaderLogo } from '@/components/Header/styles'
import { MenuButtonBack } from '@/components/MainSidebar/styles'

import { Container } from '../styles'

export const BGContainer = styled(Container)`
  position: relative;
  background-image: url(${bgImg});
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: auto 900px;
  & ${HeaderElem} {
    height: 160px;
    justify-content: flex-end;
    padding-right: 96px;
  }
  & ${HeaderLogo} {
    width: 140px;
  }
`
export const ContentContainer = styled.div`
  position: relative;
  margin-left: 224px;
  margin-right: 96px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 580px;
  margin-bottom: 40px;
`
export const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 796px;
  margin-top: -20px;
`
export const InformationWrapper = styled.div`
  position: relative;
  margin: 0 0 24px;
  width: 796px;
`
export const InformationTitle = styled.div`
  position: relative;
  margin-bottom: 10px;
  width: 100%;
  font-size: 20px;
  color: ${(props) => props.theme.colors.title};
  line-height: 1.2em;
  font-weight: 500;
  text-transform: uppercase;
`
export const InformationDetails = styled.div<{
  $withLogo?: boolean
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 100%;
  min-height: ${({ $withLogo }) => ($withLogo ? '88px' : 'auto')};
  padding: 20px ${({ $withLogo }) => ($withLogo ? '152px' : '24px')} 20px 24px;
  background: ${(props) => props.theme.colors.eventDetail.background};
  border-radius: 8px;
  overflow: hidden;
`
export const InformationText = styled.div`
  font-size: 20px;
  color: ${(props) => props.theme.colors.eventDetail.text};
  opacity: 0.9;
  line-height: 1.2em;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  & span {
    color: ${(props) => props.theme.colors.accent};
    text-transform: capitalize;
  }
`
export const BodyTextWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 20px;
  width: 100%;
`
export const InformationChannelLogo = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 136px;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const StyledImage = styled.img`
  object-fit: contain;
  max-width: 80%;
  max-height: 52px;
`
export const EventDisplayWrapper = styled(FocusNode)<{
  $alignContentEnd?: boolean
}>`
  position: relative;
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  justify-content: ${({ $alignContentEnd }) =>
    $alignContentEnd ? 'flex-end' : 'space-between'};
  align-items: flex-start;
  width: 100%;
  min-height: 80px;
  ${CounterWrapper} {
    margin-bottom: 20px;
  }
`
export const DeepLinkButtonWrapper = styled(FocusNode)`
  position: relative;
  min-height: 64px;
`
export const BodyText = styled.div`
  width: 100%;
  font-size: 20px;
  color: ${(props) => props.theme.colors.eventDetail.text};
  opacity: 0.9;
  line-height: 30px;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`
export const ImageBoxWrapper = styled.div`
  position: relative;
  width: 664px;
  height: 373px;
`
export const ImageBox = styled.div<{
  $withCover?: boolean
}>`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  img,
  video {
    display: block;
    min-width: 100%;
    min-height: 100%;
    object-fit: ${({ $withCover }) => ($withCover ? 'cover' : 'contain')};
    object-position: ${({ $withCover }) =>
      $withCover ? '50% 50%;' : '100% 0'};
    opacity: 0;
    transition: all 0.2s ease-out;
    border-radius: 24px;
    overflow: hidden;
    &.isVisible {
      opacity: 1;
    }
  }
`
export const ChannelLogo = styled.div`
  position: absolute;
  top: 20px;
  right: 26px;
  & div {
    justify-content: flex-end;
  }
`

export const BlockedBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`

export const BlockedImage = styled.img`
  border: 3px solid ${(props) => props.theme.colors.eventDetail.border};
  border-radius: 100%;
  padding: 10px;
  margin-right: 20px;
`

export const PopupBG = styled(Container)`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  /* transform: scale(0.75);
  transform-origin: 50% 50%;
  box-shadow: 0px 0px 100px rgba(0, 0, 0, 0.7); */
  /* May lead to chrome craches (v107) */
  /* transition: --popupBgStart 0.5s, --popupBgEnd 0.5s; */
  /* background: radial-gradient(
    85.28% 210.12% at 10.34% 14.72%,
    var(--popupBgStart) 0%,
    var(--popupBgEnd) 50%
  ); */
  background: radial-gradient(
    85.28% 210.12% at 10.34% 14.72%,
    ${(props) => props.theme.colors.app.background.start} 0%,
    ${(props) => props.theme.colors.app.background.end} 100%
  );
  z-index: 12;

  & > ${MenuButtonBack} {
    position: absolute;
    z-index: 2;
  }
`

export const EventUnavailableHeader = styled.div``

export const ColoredBodyText = styled(BodyText)<{ $hidden?: boolean }>`
  color: ${(props) => props.theme.colors.eventDetail.coloredText};
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
  display: ${({ $hidden }) => ($hidden ? 'none' : '')};
`
export const EventDetailInfo = styled.div`
  position: absolute;
  width: 115%;
  bottom: 100%;
  left: 0;
  color: white;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.2em;
  padding-bottom: 6px;

  & > span {
    color: white;
    color: ${(props) => props.theme.colors.eventDetail.coloredText};
    font-weight: 600;
    margin-right: 12px;
  }
`
